export default __webpack_public_path__ + "static/media/amity.6af43f44.png";